const usg = require('../../../../assets/images/usg.jpg');
const usgBones = require('../../../../assets/images/usg_stawy.jpg');
const doppler = require('../../../../assets/images/doppler.jpg');
const consult = require('../../../../assets/images/consult.jpg');

export const offerData = [
  {
    id: 'v-pills-usg-tab',
    target: 'usg',
    title: 'BADANIA USG',
    img: usg,
    tabTitle: 'Oferujemy kompleksową diagnostykę ultrasonograficzną (USG) wykonywaną przez doświadczonych lekarzy przy użyciu najnowocześniejszego sprzętu medycznego.',
    content: [
      {
        expanded_id: 'usg-dzieci',
        expanded_content: (
          <>
            <p>Rodzaje badania:</p>
            <ul>
              <li>USG jamy brzusznej</li>
              <li>USG układu moczowego</li>
              <li>USG ślinianek</li>
              <li>USG tarczycy</li>
              <li>USG węzłów chłonnych</li>
              <li>USG jąder</li>
              <li>USG piersi</li>
              <li>USG tkanek miękkich</li>
            </ul>
            <h5>Przygotowanie do badania:</h5>
            <p>Dziecko zgłaszające się na USG jamy brzusznej powinno być na czczo i mieć wypełniony pęcherz moczowy. W związku z tym pacjent:</p>
            <ul>
              <li>powinien powstrzymać się od jedzenia przez około 3–5 godzin przed badaniem</li>
              <li>może pić wodę niegazowaną</li>
              <li>nie powinien oddawać moczu w ciągu ostatniej godziny przed badaniem</li>
            </ul>
            <p>Dodatkowo, w dniu poprzedzającym badanie należy unikać spożywania pokarmów wzdymających i ciężkostrawnych</p>
          </>
        ),
        title: 'USG dzieci (6-18r.ż.)',
      },
      {
        expanded_id: 'usg-piersi',
        expanded_content: (
          <>
            <h5>Przygotowanie do badania:</h5>
            <ul>
              <li>Badanie najlepiej wykonać między 5. a 10. dniem cyklu menstruacyjnego</li>
            </ul>
          </>
        ),
        title: 'USG piersi',
      },
      {
        expanded_id: 'usg-brzucha',
        expanded_content: (
          <>
            <h5>Przygotowanie do badania:</h5>
            <p>Pacjent powinien zgłosić się na badanie na czczo (co oznacza powstrzymanie się od jedzenia przez 5-6 godzin przed wizytą) oraz z wypełnionym pęcherzem moczowym.
              To znaczy, przykładowo: jeśli wizyta została umówiona na godzinę 13:00, pacjent powinien wypić około 1 litr wody niegazowanej w godzinach 11:00–12:00. Od godziny 12:00 do zakończenia badania nie należy oddawać moczu
            </p>
            <ul>
              <li>W dniu badania należy unikać napojów gazowanych, palenia papierosów oraz żucia gumy</li>
              <li>W dniu poprzedzającym badanie zaleca się unikanie spożywania pokarmów wzdymających i ciężkostrawnych</li>
            </ul>
          </>
        ),
        title: 'USG jamy brzusznej',
      },
      {
        expanded_id: null,
        expanded_content: null,
        title: 'USG tarczycy i przytarczyc', 
      },
      {
        expanded_id: null,
        expanded_content: null,
        title: 'USG węzłów chłonnych',
      },
      {
        expanded_id: null,
        expanded_content: null,
        title: 'USG ślinianek',
      },
      {
        expanded_id: null,
        expanded_content: null,
        title: 'USG jąder',
      },
      {
        expanded_id: null,
        expanded_content: null,
        title: 'USG tkanek miękkich (skóra, tkanka podskórna, blizny)',
      },
      {
        expanded_id: null,
        expanded_content: null,
        title: 'USG szyi (tarczyca, przytarczyce, ślinianki, węzły chłonne)',
      },
      {
        expanded_id: 'usg-moczowego',
        expanded_content: (
          <>
            <h5>Jak przygotować się do badania USG układu moczowego?</h5>
            <p>Pacjent powinien zgłosić się na badanie z wypełnionym pęcherzem moczowym.
              Przykład: jeśli wizyta jest umówiona na godzinę 13:00, pacjent powinien wypić około 1 litr wody niegazowanej w godzinach 11:00–12:00. Od godziny 12:00 do zakończenia badania nie należy oddawać moczu
            </p>
          </>
        ),
        title: 'USG układu moczowego (nerki, moczowody, pęcherz moczowy)',
      }
    ]
  },
  {
    id: 'v-pills-doppler-tab',
    target: 'rehabilitacja',
    title: 'BADANIA USG DOPPLER',
    img: doppler,
    tabTitle: 'Badania USG Doppler pozwalają na ocenę przepływu krwi w naczyniach. To nieinwazyjna metoda diagnostyczna pozwalająca wykryć zaburzenia przepływu krwi.',
    content: [
      {
        title: 'USG Doppler tętnic szyjnych i kręgowych',
      },
      {
        title: 'USG Doppler naczyń żylnych i tętniczych kończyn',
      },
      {
        title: 'USG Doppler wątroby'
      },
    ]
  },
  {
    id: 'v-pills-usg-bones-tab',
    target: 'usg-stawow',
    title: 'BADANIA USG STAWÓW',
    img: usgBones,
    tabTitle: 'Diagnostyka ultrasonograficzna stawów umożliwia ocenę struktur tkanek miękkich stawów oraz wcześniej wykrycie zmian zapalnych, zwyrodnieniowych i pourazowych.',
    content: [
      {
        title: 'USG stawu łokciowego'
      },
      {
        title: 'USG stawu kolanowego'
      },
      {
        title: 'USG stawu skokowego'
      },
      {
        title: 'USG stawu biodrowego'
      },
      {
        title: 'USG nadgarstka'
      },
      {
        title: 'USG ścięgna Achillesa'
      },
    ]
  },
  {
    id: 'v-pills-consult-tab',
    target: 'konsultacje-lekarskie',
    title: 'KONSULTACJE LEKARSKIE',
    img: consult,
    tabTitle: 'Oferujemy specjalistyczne konsultacje lekarskie prowadzone przez doświadczonych lekarzy z różnych dziedzin medycyny.',
    content: [
      {
        title: 'Konsultacja lekarza rehabilitacji',
        expanded_id: 'konsultacja-lekarza-rehabilitacji',
        expanded_content: (
          <>
          <p>Konsultacja z doświadczonym lekarzem specjalistą rehabilitacji medycznej w przypadku urazu, operacji np. endoprotezoplastyki, występowania chronicznych dolegliwości bólowych i chorób przewlekłych pozwala na trafną diagnozę oraz indywidualne zaplanowanie odpowiednich działań terapeutycznych. </p>
          <p>W naszym Centrum świadczymy zabiegi lecznicze z wykorzystaniem najnowoczeńszych metod takie jak: kolagenoterapia, iniekcja z osocza bogatopłytkowego, iniekcja z leku przeciwbólowego i przeciwzapalnego, suche igłowanie.</p>
          </>
        )
      },
      {
        title: 'Konsultacja reumatologiczna',
        expanded_id: 'konsultacja-reumatologiczna',
        expanded_content: (
          <>
          <p>Konsultacja z lekarzem specjalistą reumatologii umożliwia zdiagnozowanie oraz leczeniem schorzeń
układu mięśniowo-szkieletowego i tkanki łącznej, które nie są spowodowane urazami
mechanicznymi.</p>
<p>Do lekarza reumatologa mogą zgłosić się osoby z dolegliwościami takimi jak: ból stawów, sztywność
poranna stawów, obrzęk stawów, ograniczenie ruchomości, a także zmiany skórne, stwardnienie
skóry, suchość błon śluzowych.
Reumatolog leczy schorzenia takie jak m.in.:</p>
<ul>
  <li>reumatoidalne zapalenie stawów (RZS)</li>
  <li>zesztywniające zapalenie stawów kręgosłupa</li>
  <li>łuszczycowe zapalenie stawów</li>
  <li>toczeń rumieniowaty układowy</li>
  <li>rumień guzowaty</li>
  <li>zapalenie wielomięśniowe</li>
  <li>twardzinę</li>
  <li>osteoporozę</li>
</ul>
<p>W naszym Centrum istnieje możliwość kwalifikacji do terapii biologicznych RZS, ŁZS, ZZSK oraz SpA-
postaci nieradiograficznych.</p>
<p>W Złota Centrum Zdrowia przeprowadzamy:</p>
<ul>
  <li>biopsję ślinianek celem diagnostyki Zespołu Sjögrena</li>
  <li>test Schirmera w przypadku podejrzenia zespołu suchego oka</li>
  <li>kapilaroskopię służącą diagnostyce oraz ocenie przebiegu leczenia chorób reumatologicznych oraz
objawu Raynauda</li>
</ul>
          </>
        )
      },
      {
        title: 'Konsultacja chirurgiczna',
        expanded_id: 'konsultacja-chirurgiczna',
        expanded_content: (
          <>
          <p>Chirurg ogólny oferuje pomoc w zakresie schorzeń wymagających interwencji zabiegowej, mniej
inwazyjnych procedur, a także leczenia zachowawczego chorób. Celem konsultacji chirurgicznej jest
ocena stanu zdrowia pacjenta i wybranie dla niego właściwej metody postępowania.</p>
<p>Do lekarza chirurga można zgłosić się m.in. w przypadku:</p>
<ul>
  <li>bólu brzucha</li>
  <li>przepukliny pachwinowej lub pępkowej</li>
  <li>kamicy pęcherzyka żółciowego</li>
  <li>zmian skórnych (np. kaszaki, tłuszczaki, włókniaki, znamiona barwnikowe „pieprzyki”)</li>
  <li>ropni, stanów zapalnych skóry i tkanek miękkich.</li>
  </ul>
  <p>W Złota Centrum Zdrowia oferujemy konsultacje chirurgiczne z dokładnym wyjaśnieniem diagnozy,
kwalifikacje do zabiegów operacyjnych w tym laparoskopowej plastyki przepuklin pachwinowych i
brzusznych, cholecystektomii, a także opiekę pooperacyjną i wizyty kontrolne.</p>
  <p>W naszym Centrum wykonujemy drobne zabiegi ambulatoryjne w znieczuleniu miejscowym, w tym
usuwanie zmian skórnych (np. kaszaki, tłuszczaki, włókniaki, znamiona barwnikowe „pieprzyki”) z ich
badaniem histopatologicznym.</p>
          </>
        )
      },
//       {
//         title: 'Konsultacja pediatryczna',
//         expanded_id: 'konsultacja-pediatryczna',
//         expanded_content: (
//           <>
//           <p>Konsultacja pediatryczna to profesjonalna pomoc medyczna dla dzieci i młodzieży od urodzenia do
// ukończenia 18. roku życia. Lekarz pediatra zajmuje się diagnostyką i leczeniem chorób,
// monitorowaniem rozwoju fizycznego i psychicznego, a także profilaktyką zdrowotną. Pediatra udziela
// także porad odnośnie żywienia i opieki nad dzieckiem.</p>
// <p>W trakcie konsultacji w Złota Centrum Zdrowia lekarz pediatra przeprowadza rzetelny wywiad
// medyczny i badanie fizykalne w przyjaznej atmosferze. W uzasadnionych przypadkach zleca badania
// obrazowe, laboratoryjne lub wykonuje dostępne w naszym Centrum szybkie testy diagnostyczne:
// CRP, Strep A, Combo: Covid-19, grypa, RSV, umożliwiające wstępną ocenę stanu zapalnego w
// organizmie, a także wykrywające infekcję wirusową oraz bakteryjną.</p>
// </>
//         )
//       },
      {
        title: 'Konsultacja neurologiczna',
        expanded_id: 'konsultacja-neurologiczna',
        expanded_content: (
          <>
          <p>Neurolog to lekarz specjalizujący się w diagnozowaniu, leczeniu oraz zapobieganiu chorobom związanych z funkcjonowaniem ośrodkowego i obwodowego układu nerwowego. Jego zadaniem jest badanie czynności układu nerwowego, do których należy m.in. sprawdzanie reakcji organizmu na bodźce. Ocenie neurologa podlegają także procesy poznawcze pacjenta, a więc: mowa, czucie, orientacja w przestrzeni, a także pamięć. </p>
<p>Neurolog leczy szeroki zakres schorzeń związanych z układem nerwowym m.in.:</p>
<ul>
  <li>bóle głowy, w tym migreny</li>
  <li>chorobę Alzheimera</li>

  <li>chorobę Parkinsona</li>

  <li>padaczkę </li>

  <li>udar mózgu, a także stany poudarowe</li>

  <li>polineuropatie</li>

  <li>stwardnienie rozsiane </li>

  <li>stwardnienie zanikowe boczne</li>

  <li>Zaburzenia ruchowe takie jak dystonie, drżenie czy zaburzenia równowagi</li>

  <li>zaburzenia snu</li>

  <li>zespół Guillaina-Barrégo</li>

  <li>zapalenie opon mózgowo-rdzeniowych </li>
</ul>
<p>Konsultacja z neurologiem jest zalecana osobom, u których występują takie objawy, jak:</p>
<ul>
<li>częste omdlenia,</li>

<li>bóle głowy,</li>

<li>zawroty głowy,</li>

<li>zaburzenia czucia,</li>

<li>problemy z koordynacją ruchową,</li>

<li>osłabienie siły mięśniowej,</li>

<li>szumy uszne,</li>

<li>drżenie mięśni,</li>

<li>tiki,</li>

<li>zaburzenia pamięci,</li>

<li>problemy z koncentracją,</li>

<li>zaburzenia mowy,</li>

<li>bezsenność.</li>
</ul>
<p>Wizyta u neurologa w Złota Centrum Zdrowia to możliwość uzyskania specjalistycznej pomocy. Podczas wizyty lekarz przeprowadza szczegółowy wywiad, badanie neurologiczne oraz, w razie potrzeby, zaleca dodatkowe badania diagnostyczne, ustala oraz prowadzi leczenie.</p>
</>
        )
      },
      {
        title: 'Konsultacja endokrynologiczna',
        expanded_id: 'konsultacja-endokrynologiczna',
        expanded_content: (
          <>
          <p>Konsultacja endokrynologiczna to specjalistyczna wizyta lekarska, której celem jest diagnostyka oraz wdrożenie indywidualnie dobranego leczenia chorób układu hormonalnego, czyli zaburzeń związanych z nieprawidłowym działaniem gruczołów wydzielania wewnętrznego. Należą do nich m.in. tarczyca, przysadka mózgowa, nadnercza, trzustka oraz jajniki i jądra. Układ hormonalny odpowiada za regulację wielu kluczowych procesów w organizmie, takich jak metabolizm, masa ciała, poziom energii, płodność, wzrost, gospodarka wapniowa czy samopoczucie. Nawet niewielkie zaburzenia hormonalne mogą wpływać na funkcjonowanie całego organizmu.</p>
          <p>Konsultacja endokrynologiczna jest zalecana m.in. w przypadku:</p>
          <ul>
          <li>podejrzenia chorób tarczycy (niedoczynność, nadczynność, choroby autoimmunologiczne),</li>
          <li>nagłych wahań masy ciała,</li>
          <li>przewlekłego zmęczenia, nadmiernej senności lub nadpobudliwości,</li>
          <li>wypadania włosów, problemów skórnych,</li>
          <li>zaburzeń miesiączkowania i problemów z płodnością,</li>
          <li>insulinooporności i zaburzeń metabolicznych,</li>
          <li>osteoporozy lub zaburzeń gospodarki wapniowej.</li>
          </ul>
          <p>W Złota Centrum Zdrowia lekarz endokrynolog zajmuje się kompleksową diagnostyką i leczeniem zaburzeń układu dokrewnego u pacjentów dorosłych, w tym chorób:</p>
          <ul>
          <li>przysadki (guzy przysadki, hiperprolaktynemia, akromegalia, choroba Cushinga, niedoczynność przysadki, moczówka prosta)</li>

          <li>tarczycy (nadczynność, niedoczynność, wole guzkowe, zapalenia: choroba Hashimoto, choroba Gravesa-Basedowa; opieka endokrynologiczna nad kobietami w ciąży)</li>
          <li>przytarczyc (nadczynność, niedoczynność)</li>
          <li>nadnerczy (guzy nadnerczy, zespół Cushinga, zespół Conna, choroba Addisona)</li>
          <li>jajników (zaburzenia miesiączkowania, hipogonadyzm, zespół policystycznych jajników – PCOS)</li>
          <li>jąder (hipogonadyzm, ginekomastia)</li>
          <li>otyłości</li>
          <li>osteoporozy</li>
          </ul>
</>
        )
      }
    ]
  },
    {
    id: 'v-pills-therapy-and-surgeries-tab',
    target: 'zabiegi-lecznicze-i-przeciwbolowe',
    title: 'ZABIEGI LECZNICZE I PRZECIWBÓLOWE',
    img: null,
    tabTitle: '',
    content: [
      {
        expanded_id: 'prp',
        expanded_content: (
          <>
<p>Osocze bogatopłytkowe (PRP) to preparat zawierający wysokie stężenie płytek krwi i czynników
wzrostu, które stymulują regenerację tkanek np. skóry, ścięgien czy kości. Uzyskiwany poprzez
pobranie od pacjenta jego własnej krwi, która jest poddawana wirowaniu. Pozyskany w ten sposób
koncentrat płytek krwi jest następnie podawany w formie zastrzyków precyzyjnie w uszkodzony
obszar, aby pobudzić procesy regeneracyjne.</p> 
<p>Osocze bogatopłytkowe ma szerokie spektrum zastosowań, w tym w rehabilitacji i ortopedii.
Wykorzystywane jest w schorzeniach takich jak:</p>
<ul>
  <li>choroba zwyrodnieniowa stawów</li>
  <li>tendinopatii rozcięgna podeszwowego</li>
  <li>łokciu tenisisty</li>
  <li>kolanie biegacza</li>
  <li>kolanie skoczka</li>
  <li>uszkodzeniach np. stożka rotatorów, skręceniach</li>
  <li>zespołach bólowych kręgosłupa.</li>
</ul>
<p>PRP może wspomagać leczenie złamań i braku zrostu po złamaniach oraz ubytków chrząstki
stawowej. Metoda ta bywa również pomocna po leczeniu operacyjnym np. po rekonstrukcji łąkotki
czy rekonstrukcji w obrębie aparatu więzadłowego.</p>
          </>
        ),
        title: 'Osocze bogatopłytkowe (PRP)',
      },
        {
        expanded_id: 'kolagenoterapia-injekcyjna',
        expanded_content: (
          <>
<p>Kolagenoterapia to małoinwazyjny zabieg iniekcyjny polegający na injekcji preparatów kolagenu do
tkanek, aby wspierać ich regenerację, odbudowę i poprawić ich funkcję.</p>
<p>Kolagen stanowi podstawowy i wszechobecny budulec wszystkich tkanek ludzkiego ciała. Znajduje się
w stanie ciągłej wymiany w procesie degradacji i syntezy. Procesy zwyrodnieniowe tkanek i procesy
starzenia są w znacznym stopniu pochodną rozpadu kolagenu oraz jego niewystarczającej produkcji.</p>
<p>Celem terapii jest uzupełnienie ubytków kolagenu. Metoda wskazana jest w bólach w przebiegu
zmian zwyrodnieniowych stawów obwodowych (bark, ręka, biodro, kolano, stopa i inne) oraz w
pewnych ściśle określonych wskazaniach w obrębie kręgosłupa.</p>
          </>
        ),
        title: 'Kolagenoterapia injekcyjna',
      },
        {
        expanded_id: 'iniekcja-z-lekiem-przeciwbolowym-i-przeciwzapalnym-blokada',
        expanded_content: (
          <>
<p>Iniekcja z lekiem przeciwbólowym i przeciwzapalnym potocznie nazywana blokadą to jeden z
małoinwazyjnych sposobów łagodzenia bólu stosowany w rehabilitacji, ortopedii czy reumatologii.
Polega na miejscowym podaniu leku o właściwościach przeciwbólowych i przeciwzapalnych. Środek
jest podawany w formie iniekcji, najczęściej pod kontrolą USG i dzięki temu można precyzyjnie trafić
w źródło bólu.</p>
<p>Blokadę stosuje się w przypadku silnych dolegliwości bólowych, które utrudniają codzienne
funkcjonowanie, a przyjmowane wcześniej środki farmakologiczne nie przyniosły pożądanych
efektów.
Zabieg wykorzystywany jest w:</p>
<ul>
  <li>silnym bólu w przebiegu choroby zwyrodnieniowej stawów</li>
  <li>zapaleniu kaletek maziowych np. kaletki podbarkowej czy okołokrętarzowej</li>
  <li>tendinopatiach i entezopatiach np.: łokciu tenisisty, łokciu golfisty, kolanie skoczka</li>
  <li>zespole cieśni nadgarstka</li>
  <li>chorobie de Quervaina</li>
  <li>okołokręgosłupowo</li>
</ul>
<p>Zastosowanie steroidów oraz ukierunkowanej na dany problem rehabilitacja może przynieść
długotrwałe efekty oraz istotnie poprawić jakość i komfort życia, pozbawiając pacjentów ograniczeń
ruchowych. Blokady sterydowe stosuje się również w procedurach diagnostycznych w celu
znalezienia źródła bólu.</p>
          </>
        ),
        title: 'Iniekcja z lekiem przeciwbólowym i przeciwzapalnym "blokada"',
      },
        {
        expanded_id: 'zabieg-suchego-igłowania',
        expanded_content: (
          <>
 <p>Igłoterapia sucha to metoda terapeutyczna, małoinwazyjna, która znajduje zastosowanie u pacjentów z przewlekłym i ostrym bólem w mięśniowo-powięziowych punktach spustowych (tzw. trigger points). 
               Polega na mechanicznym oddziaływaniu na wybraną strukturę anatomiczną za pomocą wprowadzanej przez skórę cienkiej, sterylnej igły, bez podawania (iniekcji) jakichkolwiek preparatów farmakologicznych. Przed przystąpieniem do nakłucia mięśnia, przeprowadzane jest dokładne badanie, które ma na celu zlokalizowanie napiętego pasma o zwiększonej wrażliwość na nacisk. Głównym mechanizmem oddziaływania igłoterapii suchej, bez względu na okolicę aplikacji, jest wywoływanie procesów odwrażliwienia obwodowego (desensytyzacji obwodowej) tym samym poprawa funkcjonalności pacjenta.</p>
             <p>Warto podkreślić, że suche igłowanie nie jest tożsame z zabiegami akupunkturowymi. Mimo, że obie metody wykorzystują igły akupunkturowe, sama metodyka zabiegów oraz efekt terapeutyczny różnią się od siebie. Suche igłowanie ma zastosowanie we wszelakiego rodzaju schorzeniach z towarzyszącym przeciążeniem mięśni np.: </p>
             <ul>
               <li>kolanie skoczka</li>
               <li>łokciu tenisisty łokciu golfisty</li>
               <li>bólu okolicy okołokrętarzowej biodra</li>
               <li>bólu kręgosłupa</li>
               <li>zespole bolesnego barku</li>
               <li>zespole pasma biodrowopiszczelowego</li>
               <li>napięciowym bólem głowy</li>
               <li>shin splints</li>
             </ul>
          </>
        ),
        title: 'Zabieg suchego igłowania',
      },
    ]
  },
   {
    id: 'v-pills-surgeries-tab',
    target: 'zabiegi-chirurgiczne',
    title: 'ZABIEGI CHIRURGICZNE',
    img: null,
    tabTitle: '',
    content: [
      {
        expanded_id: 'zabieg-usunięcia-zmiany-skórnej',
        expanded_content: (
          <>
          <p>W naszym Centrum wykonujemy drobne zabiegi ambulatoryjne w znieczuleniu miejscowym takie jak usuwanie zmian skórnych (np. kaszaki, tłuszczaki, włókniaki, znamiona barwnikowe „pieprzyki”).</p>
            <p>Usunięte tkanki zostają następnie poddane badaniu histopatologicznemu, które polega na
mikroskopowej analizie przez patomorfologa. Pozwala to na dokładne określenie charakteru zmiany
(łagodny, przedrakowy, złośliwy).</p>
          </>
        ),
        title: 'Zabieg usunięcia zmiany skórnej',
      },
    ]
  },
//   {
//     id: 'v-pills-therapy-tab',
//     target: 'zabiegi-lecznicze',
//     title: 'ZABIEGI LECZNICZE',
//     img: null,
//     tabTitle: 'Przeprowadzamy szeroki zakres zabiegów leczniczych wykonywanych przez doświadczonych lekarzy z wykorzystaniem najnowoczeńszych metod.',
//     content: [
//       {
//         expanded_id: 'leczenie-ortobiologiczne',
//         expanded_content: (
//           <>
//           <p>Leczenie ortobiologiczne jest jednym z głównych nurtów rozwoju rehabilitacji i stanowi pomoc w procesie leczenia bólu i rekonwalescencji po urazach i leczeniu operacyjnym. Jego istotą jest połączenie medycyny i biotechnologii. </p><p>Osocze bogatopłytkowe (PRP) i kolagenioterapia, zabiegi które oferujemy Państwu w naszym Centrum to zaawansowane formy terapii wykorzystujące naturalne procesy regeneracyjne organizmu. Wspierają go w naprawie uszkodzonych tkanek w schorzeniach takich jak: </p>
//             <ul>
//             <li>choroba zwyrodnieniowa stawów</li>
//             <li>stanach zapalnych w obrębie tkanek miękkich np. łokciu tenisty</li>
//             <li>tendinopatii rozcięgna podeszwowego</li>
//             <li>kolanie biegacza</li>
//             <li>kolanie skoczka</li>
//             <li>uszkodzeniach np. stożka rotatorów, skręceniach</li>
//             <li>zespołach bólowych kręgosłupa np "szyi smartfonowej"</li>
//             </ul>
//             <p>
// Metody te bywają również pomocne po leczeniu operacyjnym np.
// po rekonstrukcji łąkotki czy
// rekonstrukcji w obrębie aparatu więzadłowego.
// W praktyce lekarskiej w Centrum Zdrowia Złota zastosowanie ma również iniekcja sterydowa potocznie zwana "blokadą", której celem najczęściej jest szybkie uśmierzenie ostrego bólu w obrębie narządu ruchu ale może ona mieć również walor diagnostyczny przy znalezieniu bezpośredniej przyczyny dolegliwości np. przez blokadę nerwu obwodowego.
// Niezwykle istotne w małoinwazyjnych sposobach leczenia bólu, urazów sportowych czy blokad fizjologicznych procesów starzenia się organizmu jest wykonywanie procedur pod kontrolą USG co pozwala na precyzyjne podanie medykamentu do miejsca, w którym jego działanie będzie powodować najlepsze efekty.
// Wymienione zabiegi małoinwazyjne wymagają kontroli lekarskiej celem ustalenia drogi postępowania.</p>
//           </>
//         ),
//         title: 'Leczenie ortobiologiczne',
//       },
//       {
//         expanded_id: 'suche-iglowanie',
//         expanded_content: (
//           <>
//           <p>Igłoterapia sucha to metoda terapeutyczna, małoinwazyjna, która znajduje zastosowanie u pacjentów z przewlekłym i ostrym bólem w mięśniowo-powięziowych punktach spustowych (tzw. trigger points). 
//               Polega na mechanicznym oddziaływaniu na wybraną strukturę anatomiczną za pomocą wprowadzanej przez skórę cienkiej, sterylnej igły, bez podawania (iniekcji) jakichkolwiek preparatów farmakologicznych. Przed przystąpieniem do nakłucia mięśnia, przeprowadzane jest dokładne badanie, które ma na celu zlokalizowanie napiętego pasma o zwiększonej wrażliwość na nacisk. Głównym mechanizmem oddziaływania igłoterapii suchej, bez względu na okolicę aplikacji, jest wywoływanie procesów odwrażliwienia obwodowego (desensytyzacji obwodowej) tym samym poprawa funkcjonalności pacjenta.</p>
//             <p>Warto podkreślić, że suche igłowanie nie jest tożsame z zabiegami akupunkturowymi. Mimo, że obie metody wykorzystują igły akupunkturowe, sama metodyka zabiegów oraz efekt terapeutyczny różnią się od siebie. Suche igłowanie ma zastosowanie we wszelakiego rodzaju schorzeniach z towarzyszącym przeciążeniem mięśni np.: </p>
//             <ul>
//               <li>kolanie skoczka</li>
//               <li>łokciu tenisisty łokciu golfisty</li>
//               <li>bólu okolicy okołokrętarzowej biodra</li>
//               <li>bólu kręgosłupa</li>
//               <li>zespole bolesnego barku</li>
//               <li>zespole pasma biodrowopiszczelowego</li>
//               <li>napięciowym bólem głowy</li>
//               <li>shin splints</li>
//             </ul>
//           </>
//         ),
//         title: 'Zabieg suchego igłowania',
//       },
//       {
//         title: 'Zabieg usunięcia zmiany skórnej + badanie histopatologiczne',
//       }
//     ]
//   },
  {
    id: 'v-pills-diagnostics-tab',
    target: 'zabiegi-diagnostyczne',
    title: 'ZABIEGI DIAGNOSTYCZNE',
    img: null,
    tabTitle: null,
    content: [
      {
        title: 'Test Schirmera',
        expanded_id: 'test-schirmera',
        expanded_content: (
          <>
          <p>Test Schirmera (badanie wydzielania łez) to podstawowy test w przypadku podejrzenia o zespół suchego oka. Dzięki temu badaniu możemy ocenić ilość łez wyprodukowanych w ciągu 5 minut oraz czas jaki zostają one na powierzchni.
            Wskazania do przeprowadzenia testu Schirmera dotyczą zwykle uciążliwości, takich jak:</p>
          <ul>
              <li>światłowstręt</li>
              <li>bolesność gałek ocznych</li>
              <li>zaczerwienienie oczu</li>
              <li>uczucie pieczenia oczu</li>
              <li>wrażenie ciała obcego w oku (np. drobin piasku pod powieką)</li>
          </ul>
         
      </>
        )
      },
      {
        title: 'Biopsja gruczołu ślinowego',
        expanded_id: 'biopsja-wargowych-gruczolow-slinowych',
        expanded_content: (
          <>
          <p>Biopsja gruczołu ślinowego mniejszego stosowana jest w diagnostyce zespołu Sjogrena. 
              Jest to małoinwazyjna procedura wykonywana w znieczuleniu miejscowym, która dostarcza informacji na temat obecności ognisk limfocytarnego nacieku zapalnego.</p>
            <p>Biopsje wykonuje się w obrębie prawidłowej błony śluzowej wargi dolnej. Najbardziej wskazaną techniką jest linijne i podłużne nacięcie skalpelem ok. 1-1,5 cm rownolegle do czerwieni wargowej i pobranie ok. 2-3 gruczołów ślinowych do badania histopatologicznego.</p>
          </>
        )
        },
      {
        title: 'Biopsja cienkoigłowa',
        expanded_id: 'biopsja-cienkoiglowa',
        expanded_content: (
          <>
          <p>Biopsja aspiracyjna celowana cienkoigłowa (BACC) to małoinwazyjne badanie diagnostyczne, które
polega na pobraniu materiału komórkowego z podejrzanej zmiany przy użyciu cienkiej igły. Zabieg
ten jest precyzyjny, wykonywany pod kontrolą USG. Następnie pobrany materiał poddawany jest
ocenie mikroskopowej przez lekarza patomorfologa w celu oceny charakteru zmiany (złośliwa czy
łagodna).</p>
<p>W zależności od wyników biopsji, lekarz podejmuje decyzję o dalszym
postępowaniu. Wczesna diagnoza zwiększa szanse na całkowite wyleczenie.</p>
<p>W Złota Centrum Zdrowia wykonujemy biopsję cienkoigłową:</p>
          <ul>
            <li>tarczycy</li>
            <li>węzłów chłonnych</li>
          </ul>
          <p>Biopsja cienkoigłowa tarczyca ma zastosowanie w przypadku występowania zmian ogniskowych w
tarczycy oraz podejrzenia obecności zmian zapalnych tarczycy o ostrym lub podostrym przebiegu.</p>
<p>Biopsja cienkoigłowa węzłów chłonnych pozwala na potwierdzenie lub wykluczenie chorób, w tym
nowotworów układu limfatycznego (chłoniaki), przerzutów nowotworowych, a także określenie innej
przyczyny utrzymującego się powiększenia lub nieprawidłowej budowy węzłów chłonnych m.in.
choroby zakaźne (np. gruźlica), HIV, sarkoidoza.</p>
          </>
        ),
      },
      {
        title: 'Kapilaroskopia',
        expanded_id: 'kapilaroskopia',
        expanded_content: (
          <>
            <p>Kapilaroskopia jest bezbolesnym i nieinwazyjnym badaniem, które polega na ocenie mikrokrążenia krwi w naczyniach włosowatych w obrębie skóry i błon śluzowych, głównie naczyń wału paznokciowego.</p>
            <p>Badanie wykonuje się celem diagnostyki, oceny przebiegu oraz leczenia układowych chorób tkanki łącznej m.in. twardziny układowej, mieszanej choroby tkanki łącznej (zapalenia skórno-mięśniowego i zapalenia wielomięśniowego) oraz objawu Raynauda (kolejno: zblednięcie, zasinienie a następnie zaczerwienienie skóry palców pod wpływem zimna).</p>
            <br />
            <h5>Przygotowanie do badania:</h5>
            <ul>
              <li>Przed wykonaniem badania kapilaroskopii nie należy pić kawy i mocnej herbaty oraz powstrzymać się od palenia papierosów (min. 5 godzin przed badaniem).</li>
              <li>24 godziny przed badaniem nie powinno się spożywać alkoholu.</li>
              <li>3 tygodnie przed badaniem nie można wykonywać żadnych zabiegów kosmetycznych rąk, m.in. nie należy wycinać skórek przy płytce paznokcia i wykonywać manicure.</li>
              <li>W dniu badania należy się zgłosić około 15 minut wcześniej, aby nastąpiła aklimatyzacja do temperatury pokojowej.</li>
            </ul>
          </>
        ),
      },
    ]
  },
  // {
  //   id: 'v-pills-pediatrics-tab',
  //   target: 'weekend-z-pediatra',
  //   title: 'WEEKEND Z PEDIATRĄ',
  //   img: null,
  //   content: [
  //     {
  //       title: 'Jeśli dziecko zachorowało w weekend, nasze Centrum Zdrowia jest otwarte!',
  //       expanded_id: 'weekend-z-pediatra',
  //       expanded_content: (
  //         <>
  //         <p>Weekend z pediatrą w Złota Centrum Zdrowia to wyjątkowa okazja, by skonsultować się z doświadczonym lekarzem pediatrą, także w sytuacjach nagłych.</p>
  //         <p>W soboty lub niedziele zapewniamy dzieciom (0-18rż.) pomoc w zakresie:</p>
  //         <ul>
  //             <li>porad infekcyjnych: w gabinecie dostępne szybkie testy umożliwiające wstępną ocenę stanu zapalnego lub infekcji w organizmie, a także wykrywające infekcję wirusową oraz bakteryjną, w tym grypę, RSV, Covid-19, anginę bakteryjną</li>
  //             <li>diagnostyki i leczenia chorób wieku dziecięcego</li>
  //             <li>monitorowania rozwoju</li>
  //             <li>badań profilaktycznych</li>
  //         </ul>
  //        <p>Jak umówić wizytę?</p>
  //        <p>Aby skorzystać z konsultacji pediatrycznej w weekend, wystarczy:</p>
  //        <ul>
  //         <li>Zarejestrować się telefonicznie – numer znajdziesz w zakładce „Kontakt”.</li>
  //         <li>Lub zarezerwować wizytę online przez nasz system rejestracji.</li>
  //        </ul>
  //     </>
  //       )
  //     },
  //   ]
  // },
]